import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.querySelectorAll('.restaurant').forEach((item)=>{

// Расширенная версия с точной подстройкой под изображения
const slider = item.querySelector('.restaurant__slider.swiper');
const slides = item.querySelectorAll('.restaurant__slider-img');

// Функция для установки точной ширины слайдов
function setSlidesWidth() {
  slides.forEach(slide => {
	console.log('slide',slide)
    const img = slide.querySelector('img');
    if (img && img.complete) {
      // Устанавливаем ширину слайда равной ширине изображения
      slide.style.width = `${img.width}px`;
    } else if (img) {
      // Ждем загрузки изображения
      img.addEventListener('load', function() {
        slide.style.width = `${this.width}px`;
      });
    }
  });
}

// Инициализация Swiper
const restaurantSlider = new Swiper(item.querySelector('.restaurant__slider.swiper'), {
  slidesPerView: 'auto',
  spaceBetween: 8,
  loop: true,
  navigation: {
    nextEl: item.querySelector('.nav__next'),
    prevEl: item.querySelector('.nav__prev'),
  },
  mousewheel1: {
    enabled: true,
    sensitivity: 1,
    thresholdDelta: 30,
  },
  freeMode: true,
  speed: 400,
  grabCursor: true,
  on: {
    init: function() {
      setSlidesWidth();
    },
    resize: function() {
      setSlidesWidth();
    }
  }
});

// Вызываем при загрузке страницы
window.addEventListener('load', setSlidesWidth);

})